import { Action } from '../actions/vehicle-profile';

const defaultState = {
  isSaving: false,
  isFetching: false,
  isDeleting: false,
  wasDeleted: false,
  vehicle: null,
  error: undefined,
  resetSelections: false,
};

export default function vehicleProfileReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.VehicleProfile.CreateVehicleProfilePending:
      return {
        ...state,
        error: undefined,
        isSaving: true,
      };

    case Action.VehicleProfile.CreateVehicleProfileCompleted:
      return {
        ...state,
        isSaving: false,
        vehicle: body.vehicle,
        resetSelections: true,
      };

    case Action.VehicleProfile.CreateVehicleProfileFailed:
      return {
        ...state,
        isSaving: false,
        error: 'An error occurred adding vehicle profile. Please try again later.',
      };

    case Action.VehicleProfile.UpdateVehicleProfilePending:
      return {
        ...state,
        error: undefined,
        isSaving: true,
      };

    case Action.VehicleProfile.UpdateVehicleProfileCompleted:
      if (typeof window !== 'undefined') { // require this check as tests would break since they dont get window instance
        window.location = `/account/vehicles/${body.guid}`;
      }

      return {
        ...state,
        isSaving: false,
        vehicle: body,
      };

    case Action.VehicleProfile.UpdateVehicleProfileFailed:
      return {
        ...state,
        isSaving: false,
        error: body?.response?.message
          || 'An error occurred updating vehicle profile. Please try again later.',
      };

    case Action.VehicleProfile.FetchVehicleProfilePending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };

    case Action.VehicleProfile.FetchVehicleProfileCompleted:
      return {
        ...state,
        isFetching: false,
        vehicle: body,
        resetSelections: false,
      };

    case Action.VehicleProfile.FetchVehicleProfileFailed:
      return {
        ...state,
        isFetching: false,
        error: 'Error retrieving vehicle profile',
      };

    case Action.VehicleProfile.DeleteVehicleProfilePending:
      return {
        ...state,
        error: undefined,
        isDeleting: true,
      };

    case Action.VehicleProfile.DeleteVehicleProfileCompleted:
      return {
        ...state,
        isDeleting: false,
        wasDeleted: true,
      };

    case Action.VehicleProfile.DeleteVehicleProfileFailed:
      return {
        ...state,
        isDeleting: false,
        error: 'An error occurred removing vehicle profile. Please try again later.',
      };

    case Action.VehicleProfile.ResetSavingStatus:
      return {
        ...state,
        isSaving: false,
        error: undefined,
        vehicle: null,
      };

    case Action.VehicleProfile.ResetSelectionStatus:
      return {
        ...state,
        resetSelections: false,
      };

    default:
      return state;
  }
}
